@for (option of options; track option; let i = $index) {
  <div class="changelog-activity">
    {{ getTranslation()(option.activity || option.service) }}
    @if (option.charged) {
      <mat-icon class="activity-icon">euro</mat-icon>
    }
    @if (option.locked) {
      <mat-icon class="activity-icon">lock</mat-icon>
    }
  </div>
}
